var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-table',{attrs:{"table-ref":"requests-table","title":"Requests","icon":"fa fa-share-alt","hide-org-badge":"","show-search":false,"url":'/actions/site/' + _vm.rowData.id + '/null/rt',"fields":_vm.fields,"detail-component":"requests-detail-row"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }